import { Component, OnInit, inject, TemplateRef } from "@angular/core";
import { ThemeOptions } from "../../../../../theme-options";
import { Router } from "@angular/router";
import { LogedInUserService } from "../../../../../Services/loged-in-user.service";
import { CrudService } from "../../../../../Services/crud.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ROLE } from "src/app/Utils/const";
import { FormStateService } from "src/app/Services/form.service";

@Component({
  selector: "app-user-box",
  templateUrl: "./user-box.component.html",
  standalone: false,
  styles: [
    `
      .custom-close {
        background: none;
        border: none;
        font-size: 1.5rem;
        line-height: 1;
        padding: 0.25rem 0.5rem;
        margin-bottom: 2px;
        cursor: pointer;
        color: #000;
      }

      ._tas-user-info {
        margin-left: 0.25rem !important;
        padding-left: 0.25rem !important;
      }
    `,
  ],
})
export class UserBoxComponent implements OnInit {
  form: UntypedFormGroup;
  ROLE = ROLE;
  submitted = false;
  showLicenseManage: boolean = false;
  DEAULT_ERROR_MESSAGE = {
    PASSWORD: "Password is require.",
    CONFIRM_PASSWORD: "Confirm Password is require.",
  };

  model = new CompanyRegistrationModel(
    this.DEAULT_ERROR_MESSAGE.PASSWORD,
    this.DEAULT_ERROR_MESSAGE.CONFIRM_PASSWORD
  );

  logedInUser: {
    username: "  ";
    email: " ";
    roleId: any;
  };

  activeLicense = false;

  toggleDrawer() {
    this.globals.toggleDrawer = !this.globals.toggleDrawer;
  }

  constructor(
    public globals: ThemeOptions,
    private router: Router,
    private logedInUserService: LogedInUserService,
    private crudService: CrudService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private formStateService: FormStateService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }
  companyId;
  ngOnInit() {
    let self = this;
    self.logedInUserService.get(function (response) {
      self.logedInUser = response;
      // console.log("user is loggedin");
      if (response && response.companyId) {
        if (response.roleId) {
          const { Administrator = null } =
            ROLE.find((role) => role.Administrator) || {};
          const { ReadOnly = null } = ROLE.find((role) => role.ReadOnly) || {};

          if (
            Administrator &&
            ReadOnly &&
            !response.roleId.includes(Administrator)
          ) {
            self.onLogout();
          }
          if (Administrator && ReadOnly && response.roleId.includes(ReadOnly)) {
            self.onLogout();
          }
        }
        self.companyId = response.companyId;
        //  self.fetchData(response.companyId);
      }
      self.showActiveLicense();
    });

    this.form = this.formBuilder.group({
      oldPassword: ["", Validators.required],
      password: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$"
          ),
        ],
      ],
      confirmPassword: ["", [Validators.required, this.passwordValidator()]],
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.formStateService.setFormDirty();
      }
    });

    self.showLicenseManagement();
  }

  showActiveLicense() {
    if (this.logedInUser.roleId) {
      const { Administrator = null } =
        ROLE.find((role) => role.Administrator) || {};
      const { ReadOnly = null } = ROLE.find((role) => role.ReadOnly) || {};

      if (
        Administrator &&
        ReadOnly &&
        this.logedInUser.roleId.includes(Administrator) &&
        !this.logedInUser.roleId.includes(ReadOnly)
      ) {
        this.activeLicense = true;
      }
    }
  }

  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control.parent;

      if (!formGroup) {
        return null;
      }

      const password = formGroup.get("password").value;
      const confirmPassword = formGroup.get("confirmPassword").value;

      let match = false;

      match = password !== confirmPassword;

      if (match) {
        return { match: true };
      }

      return null;
    };
  }

  viewActiveLicense() {
    document.getElementById("icon-active").click();
    this.router.navigate(["/page/project-license-information"]);
  }

  viewlistOfCompanies() {
    this.router.navigate(["/page/list-of-companies"]);
  }
  onLogout() {
    if (
      (globalThis as any).TASClient &&
      typeof (globalThis as any).TASClient.resetAppRoleRelId === "function"
    ) {
      // if(userInfo)
      let rolesArray = localStorage
        .getItem("roles")
        .split(",")
        .map((role) => role.trim());

      (globalThis as any).TASClient.resetAppRoleRelId()
        .then(() => {
          console.log("Removing icons : success");
        })
        .catch((error) => {
          console.error("Removing icons : failed", error);
        });
    } else {
      console.log("UFOreseticonsettings is not accessible or not a function");
    }
    let self = this;
    self.crudService.post(
      { accessToken: localStorage.getItem("access_token") },
      function (response) {},
      "userManagements/logout?access_token=" +
        localStorage.getItem("access_token")
    );
    localStorage.removeItem("access_token");
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  onSubmit() {
    let self = this;
    self.submitted = true;

    // stop here if form is invalid
    if (self.form.invalid) return;

    // submit API call
    var payload = {
      oldPassword: self.form.value.oldPassword,
      newPassword: self.form.value.password,
    };

    self.logedInUserService.get(function (logedInUser) {
      self.crudService.post(
        payload,
        function (response) {
          if (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            }
          } else {
            self.toastr.success(
              self.translateService.instant(
                "Form.SuccessMessage.UpdatePassword"
              ),
              "Success"
            );
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
            self.onLogout();
            self.closeModal();
          }
        },
        "userManagements/change-password"
      );
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onReset() {
    this.submitted = false;
    this.form.reset();
    setTimeout(() => {
      this.form.markAsPristine();
      this.formStateService.clearFormDirty();
    }, 1000);
  }

  closeResult = "";

  open(content: TemplateRef<any>) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
        keyboard: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }

  showLicenseManagement() {
    let self = this;
    self.logedInUserService.get(function (logedInUser) {
      const isSuperAdmin = logedInUser.roleId.some((id) => {
        return Object.values(self.ROLE[6])[0] === id.toString();
      });

      self.showLicenseManage = isSuperAdmin;
    });
  }
}

class CompanyRegistrationModel {
  constructor(public password?: string, public confirmPassword?: string) {}
}
